import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { VehicleAreaRoutes } from '@backoffice-frontend/vehicle-api'
import { VehicleIcon } from '@moia-dev/pace-icons'

export const VehicleAreaNavigationIcon = VehicleIcon

export const VehicleAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleAreaRoutes.Table.route}
      Icon={VehicleIcon}
    />
  )
}
